module.exports = __webpack_public_path__ + "img/points.e14f8feb.svg";